/**
 * Application configuration
 *
 * In development, API calls go to the local proxy (Vite handles this).
 * In production, API calls go directly to the Worker.
 */

export const config = {
  // In production on custom domain, use relative paths (same origin)
  // This ensures cookies work correctly (first-party)
  apiBaseUrl: import.meta.env.PROD
    ? ''  // Same domain - use relative URLs
    : '',

  // WebSocket URL for real-time features
  wsBaseUrl: import.meta.env.PROD
    ? `wss://${window.location.host}`  // Same domain
    : `ws://${window.location.host}`,
};

/**
 * Build a full API URL
 */
export function apiUrl(path: string): string {
  return `${config.apiBaseUrl}${path}`;
}

/**
 * Build a WebSocket URL
 */
export function wsUrl(path: string): string {
  return `${config.wsBaseUrl}${path}`;
}
